"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = require("styled-components");
var asRendition_1 = require("../asRendition");
var utils_1 = require("../utils");
var Base = styled_components_1.default.hr(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tborder: none;\n\theight: ", ";\n\tbackground-color: ", ";\n"], ["\n\tborder: none;\n\theight: ", ";\n\tbackground-color: ", ";\n"])), function (props) { return utils_1.px(props.height || 2); }, function (props) { return props.color || '#333'; });
exports.default = asRendition_1.default(Base, [], ['color']);
var templateObject_1;



//////////////////
// WEBPACK FOOTER
// /Users/dnlytras/.npm/_npx/11246/lib/node_modules/landr/theme/node_modules/rendition/dist/components/Divider.js
// module id = 143
// module chunks = 2